import { useEffect } from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth-store'
import { isJwtExpired } from '@/utils/jwt'

export function ProtectedRoute() {
  const { isAuthenticated, accessToken, clearAuth } = useAuthStore()
  const navigate = useNavigate()

  const tokenExpired = isAuthenticated && accessToken != null && isJwtExpired(accessToken)

  useEffect(() => {
    if (tokenExpired) clearAuth()
  }, [tokenExpired, clearAuth])

  useEffect(() => {
    function handleSessionExpired() {
      clearAuth()
      navigate('/login', { replace: true })
    }

    window.addEventListener('navega:session-expired', handleSessionExpired)
    return () => window.removeEventListener('navega:session-expired', handleSessionExpired)
  }, [clearAuth, navigate])

  if (!isAuthenticated || tokenExpired) return <Navigate to="/login" replace />

  return <Outlet />
}
